import { Avatar as MaterialAvatar, SxProps } from '@mui/material';
import React from 'react';

import type { Theme } from '../../themes/themes';

export interface AvatarProps {
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
  src?: string;
  alt?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ children, ...props }: AvatarProps) => {
  const sx: AvatarProps['sx'] = Object.assign({}, props.sx);
  return (
    <MaterialAvatar sx={sx} {...props}>
      {children}
    </MaterialAvatar>
  );
};
